import { configurar } from "@nhomi/dados";
import { auth, db, functions, storage } from "./firebase";
import { EXTENSAO } from "./image";
import { subirTodos } from "./upload";

/* ============================================================
   Entregar ao `@nhomi/dados` o que é do site

   As consultas ao Firestore são as mesmas nos dois apps e vivem num
   pacote só. O que NÃO é igual é entregue aqui, uma vez, na abertura —
   o porquê de cada item está no `ambiente.ts` do pacote.

   Este arquivo é importado por `main.tsx` ANTES de qualquer tela. Nada
   no pacote lê o ambiente no topo de módulo (todo uso acontece dentro de
   função), então a ordem real é: módulos carregam, isto roda, e só
   depois alguma tela pede dado.
   ============================================================ */

configurar({
  db,
  storage,
  auth,
  functions,

  /* No site ela é decidida por detecção: o navegador que sabe fazer WebP
     salva WebP, e os outros salvam JPEG. */
  extensao: EXTENSAO,

  /* O ÚNICO molde deste arquivo, e ele é onde a diferença mora: o
     pacote não sabe o que é uma foto pronta (no site é `Blob`, no app é
     `{ uri, bytes, tipo }`), então ele declara `unknown` e repassa. Quem
     sabe é este lado, e é aqui que o tipo volta a ser um. */
  subirTodos: (arquivos, aoProgredir) =>
    subirTodos(arquivos as { caminho: string; dados: Blob }[], aoProgredir),

  bytesAleatorios: (quantos) => crypto.getRandomValues(new Uint8Array(quantos)),
});
